'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Label = require('./Label');

var _Label2 = _interopRequireDefault(_Label);

var _Choice = require('./Choice');

var _Choice2 = _interopRequireDefault(_Choice);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // NPM

// Components


var Radio = function (_Component) {
  _inherits(Radio, _Component);

  function Radio() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Radio);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Radio.__proto__ || Object.getPrototypeOf(Radio)).call.apply(_ref, [this].concat(args))), _this), _this.choiceSelected = function (choiceValue) {
      var value = _this.props.value;

      return value === choiceValue;
    }, _this.renderChoices = function () {
      var options = _this.props.options;

      return options.map(_this.renderChoice);
    }, _this.renderChoice = function (option, index) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onChange = _this$props.onChange,
          name = _this$props.name;

      var checked = _this.choiceSelected(option.value);
      return _react2.default.createElement(_Choice2.default, {
        key: index,
        defaultChecked: checked,
        type: 'radio',
        disabled: disabled,
        onClick: onChange,
        value: option.value,
        text: option.text,
        name: name
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Radio, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          text = _props.text,
          className = _props.className;

      return _react2.default.createElement(
        'div',
        { className: 'Radio-root ' + className },
        text && _react2.default.createElement(_Label2.default, { text: text }),
        _react2.default.createElement(
          'div',
          { className: 'Radio-choices-holder' },
          this.renderChoices()
        )
      );
    }
  }]);

  return Radio;
}(_react.Component);

Radio.propTypes = _extends({}, _utils.genericPropTypes);

Radio.defaultProps = _extends({}, _utils.genericDefaultProps);

exports.default = Radio;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/FormInputs/Radio.js
// module id = 201
// module chunks = 0